import type LabelValue from 'commons/modules/label-value';

import { getCurrentYear } from './helpers';

export type YearOptionsOrder = 'asc' | 'desc';

export const DEFAULT_YEAR_OPTIONS_FLOOR = 1990;

export interface GetYearOptionsParams {
  from?: number;
  to?: number;
  order?: YearOptionsOrder;
}

export const getYearOptions = ({
  from = DEFAULT_YEAR_OPTIONS_FLOOR,
  to = getCurrentYear(),
  order = 'desc',
}: GetYearOptionsParams = {}): LabelValue[] => {
  const min = Math.min(from, to);
  const max = Math.max(from, to);

  const years = Array.from({ length: max - min + 1 }, (_, i) => min + i);

  if (order === 'desc') years.reverse();

  return years.map((year) => ({ label: String(year), value: String(year) }));
};
